export default {
  "meta": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["予告編ジェネレーター - Netflix ONE PIECE"])},
    "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["尾田栄一郎原作の実写版「ONE PIECE」の公式ファンクラブ「麦わら大船団」が、究極の冒険へとあなたをいざなう。"])}
  },
  "intro": {
    "first_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ルフィの世界に入り"])},
    "wanted_poster": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["キミの海賊指名手配書を"])},
    "second_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["並べよう！"])}
  },
  "autorisation": {
    "first": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["カメラへのアクセスを </br>\n許可する"])},
    "second": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["撮影の準備ができたら </br>\nスペースキーかクリックを押す！"])},
    "btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["次へ"])},
    "legal": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["このチェックボックスを選択すると、以下に同意したものと見なされます。(1)「予告編ジェネレーター」を提供するための一環として、当社が第三者のソフトウェアを使用する場合があり、体験の利用者に第三者のソフトウェア (Impossible Software) の利用規約が適用される場合があります。(2) 体験を利用した場合、動画作成プロセスに必要な写真を取得する目的に限り、当社があなたのコンピュータまたはスマートフォンのウェブカメラにアクセスすることをあなたが許可したと見なされます。(3) 本サイトは、必要な写真以外に、あなたのウェブカメラで撮影されたいかなる映像も記録または保存することはありません。"])}
  },
  "poster": {
    "take_picture": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["写真を撮る"])},
    "advice": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["顔を画面の中央に配置"])},
    "try_again": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["やり直す"])},
    "proceed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["次へ"])},
    "pirate_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["キミの海賊名を何にする？"])},
    "max_letters": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["最大15文字"])},
    "generate_trailer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["予告映像をつくる"])}
  },
  "teaser": {
    "in_progress": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["キミの予告映像をジェネレート中。</br>\nもう少々お待ちください。"])},
    "ready": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["キミの予告映像、完成！"])},
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["キミの予告映像を見る"])},
    "download": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["キミの予告映像を </br>\nダウンロード"])},
    "try_again": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["もう一度、つくる"])}
  }
}